import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/user",

        async roles(id) {
            return await Vue.http.get(this.url(`/${id}/roles`));
        },

        async unlockLogin(id) {
            const url = this.url(`/user/${id}/unlock`);

            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.put(url, {}).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async password({ id, oldPassword, newPassword }) {
            if (!id) throw new Error("Id not specified");

            const url = this.url(`/user/${id}/senha`);

            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .put(url, {
                    senha: newPassword,
                    senhaAtual: oldPassword,
                })
                .catch((error) => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async load({ pagination, filters }) {
            const url = this.url(
                `/${pagination.page}/${pagination.amountPerPage}`
            );
            const query = {
                filtro: filters.search,
                ordem: "nome",
                tipoUsuario: filters.userType,
                desc: false,
            };
            return await Vue.http.get(url, {
                params: query,
            });
        },

        async clearCache() {
            const message = await Vue.http.post(this.url(`/limpar-cache`), {});
            return message;
        },
    },
    base
);
